function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTreble2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8.9859571mm",
    height: "25.985958mm",
    viewBox: "0 0 8.9859571 25.985958",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72.533559,-171.14635)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 77.026538,196.63933 v -25 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 73.026538,178.21674 h 8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 73.026538,180.64456 h 8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 73.026538,183.07238 h 8 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTreble2);
export default __webpack_public_path__ + "static/media/double-treble-2.f43339d7765c4b3fb8aa7843265c86e3.svg";
export { ForwardRef as ReactComponent };